export default {
    /**
     * 播放语音提示
     * @param {string} text - 要朗读的文本
     */
    play(text) {
      // 检查浏览器是否支持语音合成 API
      if ('speechSynthesis' in window) {
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = 'zh-CN'; // 设置中文语音
        window.speechSynthesis.speak(utterance);
      } else {
        console.warn('当前浏览器不支持语音合成（Web Speech API）');
      }
    },
  
    /**
     * 停止所有语音播放
     */
    stop() {
      if ('speechSynthesis' in window) {
        window.speechSynthesis.cancel();
      }
    },
  };


// WEBPACK FOOTER //
// ./src/utils/voiceNotifier.js